<template>
  <router-view />
</template>
<script></script>
<style lang="scss">
:root {
  --primary-colour: #fff;
  --secondary-colour: #d5d8e1;
  --action-colour: #3bafda;
  --text-colour: #2e2f35;
  --secondary-text-colour: #fff;
  --warning-colour: #f44336;
  --banner-colour: #2e2f35;
  --border-colour: #ecf2f8;
  --hover-colour: #ededed;
  --box-shadow: 0 0 0.5rem 0 rgba(0, 0, 0, 0.8);
  --pass-colour: #4caf50;
  --fail-colour: #f44336;
}

:root.dark-theme {
  --primary-colour: #2e2f35;
  --secondary-colour: #444548;
  --action-colour: #3bafda;
  --text-colour: #d8d5d5;
  --secondary-text-colour: #2e2f35;
  --warning-colour: #f44336;
  --banner-colour: #2e2f35;
  --border-colour: #2e2f35;
  --hover-colour: #2e2f35;
  --box-shadow: 0 0 0.5rem 0 rgba(255, 255, 255, 0.8);
  --pass-colour: #4caf50;
  --fail-colour: #f44336;
}

@media (prefers-color-scheme: dark) {
  :root {
    --primary-colour: #2e2f35;
    --secondary-colour: #444548;
    --action-colour: #3bafda;
    --text-colour: #d8d5d5;
    --secondary-text-colour: #2e2f35;
    --warning-colour: #f44336;
    --banner-colour: #2e2f35;
    --border-colour: #2e2f35;
    --hover-colour: #2e2f35;
    --box-shadow: 0 0 0.5rem 0 rgba(255, 255, 255, 0.8);
    --pass-colour: #4caf50;
    --fail-colour: #f44336;
  }

  :root.light-theme {
    --primary-colour: #fff;
    --secondary-colour: #d5d8e1;
    --action-colour: #3bafda;
    --text-colour: #2e2f35;
    --secondary-text-colour: #fff;
    --warning-colour: #f44336;
    --banner-colour: #2e2f35;
    --border-colour: #ecf2f8;
    --hover-colour: #ededed;
    --box-shadow: 0 0 0.5rem 0 rgba(0, 0, 0, 0.8);
    --pass-colour: #4caf50;
    --fail-colour: #f44336;
  }
}

body {
  margin: 0px;
  padding: 0px;
  font-family: "Lato";
  color: var(--text-colour);
  background-color: var(--primary-colour);
}

* {
  box-sizing: border-box;
}

form {
  font-size: 1em;
  label {
    display: block;
    font-size: 0.8em;
    font-weight: bold;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }
  input[type="text"],
  input[type="file"],
  input[type="number"],
  input[type="tel"],
  input[type="email"],
  input[type="password"],
  textarea,
  select {
    padding: 0.7rem;
    border-radius: 0.3rem;
    border: 1px solid #ccc;
    margin-bottom: 0.5rem;
    width: 100%;
    font-size: 1rem;
    font-family: "Lato";
    background-color: var(--primary-colour);
    color: var(--text-colour);
  }
}

button {
  padding: 1rem;
  border-radius: 0.3rem;
  border: 1px solid #ccc;
  background-color: var(--action-colour);
  font-size: 1rem;
  color: var(--secondary-text-colour);
  display: inline-block !important;
  cursor: pointer;
  font-family: "Lato";
  &:focus {
    outline: 0;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

button.primary {
  background-color: var(--action-colour) !important;
}

button.danger {
  background-color: #ff003b !important;
}

button.full-width {
  width: 100%;
  margin-left: 0 !important;
}
</style>
